import { create } from 'zustand'
import { useJsApiLoader } from '@react-google-maps/api'
import { useEffect } from 'react'
import { libraries } from './_googleLibraries/libraries'

interface MapStore {
  isApiLoaded: boolean
  setIsApiLoaded: (isLoaded: boolean) => void
  maps: Record<string, google.maps.Map>
  registerMap: (id: string, mapInstance: google.maps.Map) => void
  removeMap: (id: string) => void
}

const useMapStore = create<MapStore>((set) => ({
  isApiLoaded: false,
  setIsApiLoaded: (isLoaded: boolean) => set({ isApiLoaded: isLoaded }),
  maps: {}, // Uloženie mapy podľa ID
  registerMap: (id: string, mapInstance: google.maps.Map) =>
    set((state) => ({
      maps: {
        ...state.maps,
        [id]: mapInstance,
      },
    })),
  removeMap: (id: string) =>
    set((state) => {
      const maps = { ...state.maps }
      delete maps[id]
      return { maps }
    }),
}))

// Globálna premenná na sledovanie stavu API mimo React lifecycle
let globalIsLoaded = false

const googleMapsApiOptions = {
  id: 'google-map-script',
  // tento apikey je pre dev default, pretoze musi byt z iis-dev, kde mame api places legacy, inak by nesiel autocomplete
  googleMapsApiKey:
    import.meta.env.VITE_REACT_MAPS_API_KEY ||
    'AIzaSyBmi78rBLqXppTEMb7FaoCDClBwfbx_s3k',
  libraries,
  language: 'sk',
  region: 'sk',
}

/**
 * Hook na centralizované načítanie a manažment Google Maps API
 * @returns {Object} - Objekt obsahujúci stav načítania API a funkcie na prácu s mapami
 */
export const useMap = () => {
  const { setIsApiLoaded, maps, registerMap, removeMap } = useMapStore()

  const { isLoaded: jsApiLoaded } = useJsApiLoader(googleMapsApiOptions)

  const isLoaded = globalIsLoaded || jsApiLoaded

  useEffect(() => {
    if (jsApiLoaded && !globalIsLoaded) {
      globalIsLoaded = true

      setIsApiLoaded(true)
    }
  }, [jsApiLoaded, setIsApiLoaded])

  return {
    isLoaded,
    maps,
    registerMap,
    removeMap,
  }
}
